export default {
    name: 'ChevronUpSmall',
    dimensions: { width: 10, height: 6 },
    content: `<path fill-rule="evenodd" clip-rule="evenodd" d="M9.70711 5.70711C9.31658 6.09763 8.68342 6.09763 8.29289 5.70711L5 2.41421L1.70711 5.70711C1.31658 6.09763 0.683417 6.09763 0.292893 5.70711C-0.0976317 5.31658 -0.0976317 4.68342 0.292893 4.29289L4.29289 0.292893C4.68342 -0.0976313 5.31658 -0.0976313 5.70711 0.292893L9.70711 4.29289C10.0976 4.68342 10.0976 5.31658 9.70711 5.70711Z" fill="currentColor"/>`
};
